/* Referrals (docs/plans/phase2-referrals.md §6). Tokens only. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  min-width: 0;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

/* The list's filters: fields side by side, wrapping at 1366×768 and on phones. */
.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-3);
}

.filters > * {
  flex: 1 1 11rem;
  min-width: 0;
}

.form,
.fields {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.row > * {
  flex: 1 1 12rem;
  min-width: 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.label {
  margin: 0;
  font: var(--t-body-strong);
}

.fieldError {
  margin: 0;
  color: var(--status-error-fg);
  font: var(--t-small);
  font-weight: 600;
}

/* Prose the person wrote: reasons, summaries, notes (DESIGN.md §3, 75 characters). */
.prose {
  max-width: 75ch;
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.facts {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: var(--space-1) var(--space-4);
  margin: 0;
}

.facts dt {
  color: var(--graphite);
}

.facts dd {
  margin: 0;
  overflow-wrap: anywhere;
}

/* The facility picker. */
.picker {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.chosen,
.typed {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2);
}

.chosenName {
  margin: 0;
  font: var(--t-body-strong);
}

.pickerRow {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.pickerName {
  font: var(--t-body-strong);
  overflow-wrap: anywhere;
}

/* History: oldest first, one entry per update. */
.history {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.event {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding-bottom: var(--space-3);
  border-bottom: 1px solid var(--rule);
}

.event:last-child {
  padding-bottom: 0;
  border-bottom: none;
}

.eventTitle {
  font: var(--t-body-strong);
}

.letters {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.letter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.more {
  display: flex;
  justify-content: center;
  padding-top: var(--space-3);
}
